import {gql} from '@apollo/client';

const GET_PLANR_VEHICLES = gql`
  query GetPlanrVehicles($scheduleIds: [ID!]!) {
    getPlanrVehicles(scheduleIds: $scheduleIds) {
      id
      name
      planrBusPartner {
        busPartnerMobilityId
        busPartnerName
        busPartnerShortName
      }
    }
  }
`;

export default GET_PLANR_VEHICLES;
